module.exports = __webpack_public_path__ + "static/media/web designer.13960f6c.png";